/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankCardChangeReqVo
 */
export interface BankCardChangeReqVo {
    /**
     * 用户id
     * @type {number}
     * @memberof BankCardChangeReqVo
     */
    userId: number;
    /**
     * 卡类型 1 储蓄卡 2 信用卡
     * @type {number}
     * @memberof BankCardChangeReqVo
     */
    cardType: number;
    /**
     * 卡业务类型 1 佣金收款 2 支付
     * @type {number}
     * @memberof BankCardChangeReqVo
     */
    businessType: number;
    /**
     * 卡号
     * @type {string}
     * @memberof BankCardChangeReqVo
     */
    cardNumber: string;
    /**
     * 银行名
     * @type {string}
     * @memberof BankCardChangeReqVo
     */
    bankName: string;
    /**
     * 持卡人姓名
     * @type {string}
     * @memberof BankCardChangeReqVo
     */
    cardHolderName: string;
    /**
     * 短信验证码
     * @type {string}
     * @memberof BankCardChangeReqVo
     */
    verifyCode: string;
}

/**
 * Check if a given object implements the BankCardChangeReqVo interface.
 */
export function instanceOfBankCardChangeReqVo(value: object): value is BankCardChangeReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('cardType' in value) || value['cardType'] === undefined) return false;
    if (!('businessType' in value) || value['businessType'] === undefined) return false;
    if (!('cardNumber' in value) || value['cardNumber'] === undefined) return false;
    if (!('bankName' in value) || value['bankName'] === undefined) return false;
    if (!('cardHolderName' in value) || value['cardHolderName'] === undefined) return false;
    if (!('verifyCode' in value) || value['verifyCode'] === undefined) return false;
    return true;
}

export function BankCardChangeReqVoFromJSON(json: any): BankCardChangeReqVo {
    return BankCardChangeReqVoFromJSONTyped(json, false);
}

export function BankCardChangeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankCardChangeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'cardType': json['cardType'],
        'businessType': json['businessType'],
        'cardNumber': json['cardNumber'],
        'bankName': json['bankName'],
        'cardHolderName': json['cardHolderName'],
        'verifyCode': json['verifyCode'],
    };
}

export function BankCardChangeReqVoToJSON(json: any): BankCardChangeReqVo {
    return BankCardChangeReqVoToJSONTyped(json, false);
}

export function BankCardChangeReqVoToJSONTyped(value?: BankCardChangeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'cardType': value['cardType'],
        'businessType': value['businessType'],
        'cardNumber': value['cardNumber'],
        'bankName': value['bankName'],
        'cardHolderName': value['cardHolderName'],
        'verifyCode': value['verifyCode'],
    };
}

